<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.storeList.push"
  >
    <el-table-column width="70px" label="ID" prop="id"/>

    <v-column-time/>

    <v-column-avatar label="门店名称" avatar-key="cover" nickname-key="store_name"/>

    <el-table-column label="每月成本（元）" width="140px">
      <template v-slot="{ row }">
        <span>{{ row.cost | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="每月房租（元）" width="140px">
      <template v-slot="{ row }">
        <span>{{ row.rent | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="收入分成比" width="120px">
      <template v-slot="{ row }">
        <span>{{ row.revenue_sharing | toYuan }} %</span>
      </template>
    </el-table-column>
    <el-table-column label="前台提成比" width="120px">
      <template v-slot="{ row }">
        <span>{{ row.receptionist_percentage }} %</span>
      </template>
    </el-table-column>
    <el-table-column label="任务失败底薪比" width="120px">
      <template v-slot="{ row }">
        <span>{{ row.unfinished_rate }} %</span>
      </template>
    </el-table-column>
    <el-table-column label="业绩任务" width="140px">
      <template v-slot="{ row }">
        <el-tag v-if="row.task_enabled" type="success">已开启</el-tag>
        <el-tag v-else type="danger">未开启</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="课卡全国通用" width="140px">
      <template v-slot="{ row }">
        <el-tag v-if="row.is_generic" type="success">是</el-tag>
        <el-tag v-else type="danger">否</el-tag>
      </template>
    </el-table-column>

    <el-table-column label="操作">
      <template v-slot="{ row }">

        <v-list-button
          name="门店签到码"
          icon="mini-app-qr-code"
          size="large"
          @click="getQRCode(row.id)"
          :is-loading="isGetting[row.id]"
        />

        <v-list-button name="修改门店" size="large" :to="RouteConfig.storeEdit.to(row.id)"/>

        <v-popover>
          <v-popover-item
            icon="bin"
            name="删除门店"
            @click="handleDelete(row)"
            :is-loading="isDeleting[row.id]"
            message="删除后可在回收站恢复 , 确认要继续吗？"
          />
        </v-popover>
      </template>
    </el-table-column>
    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`store-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>门店</span>
              <v-avatar-nickname
                :value="v.cover"
                :nickname="v.store_name"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>每月成本</span>
              <span>{{ v.cost | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>每月房租</span>
              <span>{{ v.rent | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>收入分成比</span>
              <span>{{ v.revenue_sharing | toYuan }} %</span>
            </div>
            <div class="list-item-detail">
              <span>前台提成比</span>
              <span>{{ v.receptionist_percentage }} %</span>
            </div>
            <div class="list-item-detail">
              <span>任务失败底薪比</span>
              <span>{{ v.unfinished_rate }} %</span>
            </div>
            <div class="list-item-detail">
              <span>业绩任务</span>
              <el-tag v-if="v.task_enabled" type="success">已开启</el-tag>
              <el-tag v-else type="danger">未开启</el-tag>
            </div>
            <div class="list-item-detail">
              <span>课卡全国通用</span>
              <el-tag v-if="v.is_generic" type="success">是</el-tag>
              <el-tag v-else type="danger">否</el-tag>
            </div>
            <div class="list-item-button">
              <v-list-button
                name="门店签到码"
                icon="mini-app-qr-code"
                size="large"
                @click="getQRCode(v.id)"
                :is-loading="isGetting[v.id]"
              />
              <v-list-button name="修改门店" size="large" :to="RouteConfig.storeEdit.to(v.id)"/>
              <v-popover>
                <v-popover-item
                  icon="bin"
                  name="删除门店"
                  @click="handleDelete(v)"
                  :is-loading="isDeleting[v.id]"
                  message="删除后可在回收站恢复，确认要继续吗？"
                />
              </v-popover>
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { index, destroy, getQrCodeByStoreId } from '@/api/store';
import { getLegalQueryList } from "@/utils/formats";

export default {
  name: RouteConfig.storeList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    queryList: {
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
    isGetting: {},
    isLoading: false,
    isDeleting: false,
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      getLegalQueryList(queryList, route.query);

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete({ id }) {
      if (this.isDeleting) return;

      this.isDeleting = true;
      const { isError } = await destroy(id);
      this.isDeleting = false;

      if (!isError) this.load();
    },
    async getQRCode(id) {
      if (this.isLoading) return;
      const { isError, data } = await getQrCodeByStoreId(id);
      this.isLoading = false;
      if (isError) return;

      data.qr_code && window.open(data.qr_code);
    },
  },
};
</script>
